import { createAsyncThunk } from "@reduxjs/toolkit";
import portalAxios from "../portalAxios";
import { PortalBookableSlotsResponse } from "../contracts/PortalBookableSlotsResponse";
import { PortalSlotRequestRequest, PortalSlotRequestResponse } from "../contracts/PortalSlotRequestRequest";
import { mapResponseToBookableSlots } from "../../bookable-slots/mappers/BookableSlotsResponseMapper";
import { BookableSlots } from "../../bookable-slots/models/BookableSlots";
import { SlotApiError, toSlotError } from "../../bookable-slots/utils/slotApiError";

/** The target member's free slots of their assigned instructor, for the next 14 days. */
export const fetchPortalBookableSlots = createAsyncThunk<
  { memberId: string; slots: BookableSlots },
  { memberId: string },
  { rejectValue: SlotApiError }
>("portal/fetchBookableSlots", async ({ memberId }, { rejectWithValue }) => {
  try {
    const response = await portalAxios.get<PortalBookableSlotsResponse>(`/portal/members/${memberId}/bookable-slots`);
    return { memberId, slots: mapResponseToBookableSlots(response.data) };
  } catch (error) {
    return rejectWithValue(toSlotError(error));
  }
});

/** Requests one slot for the target member; Confirmed or Requested by the window's mode. */
export const requestPortalSlot = createAsyncThunk<
  { memberId: string; response: PortalSlotRequestResponse },
  { memberId: string; request: PortalSlotRequestRequest },
  { rejectValue: SlotApiError }
>("portal/requestSlot", async ({ memberId, request }, { rejectWithValue }) => {
  try {
    const response = await portalAxios.post<PortalSlotRequestResponse>(
      `/portal/members/${memberId}/slot-requests`,
      request,
    );
    return { memberId, response: response.data };
  } catch (error) {
    return rejectWithValue(toSlotError(error));
  }
});
